import React from "react";
import { useIsAuthenticated } from "@azure/msal-react";
import { SignOutButton } from "../Buttons/SignOutButton";
import { SignInButton } from "../Buttons/SignInButton";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { CustomBreadcrumbs } from "../BreadCrumbs/CustomBreadCrumbs";
import { Link } from "@mui/material";

/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props
 */

function Copyright() {
  return (
    <>
      <Typography variant="body2" color="textSecondary" align="center">
        {"Copyright © 2024 OSF Healthcare System"} |{" "}
        <Link href="https://www.osfhealthcare.org/terms/" target="_blank">
          Terms & Conditions
        </Link>
      </Typography>
    </>
  );
}
export const PageLayout = (props) => {
  const isAuthenticated = useIsAuthenticated();

  return (
    <>
      <Box sx={{ flexGrow: 1 , display:'flex-inline' }}>
        <AppBar
          sx={{ background: "white", boxShadow: "none" }}
          position="static"
        >
          
          
          <Toolbar sx={{ display: "flex", justifyContent: "flex-end" }}>
            {isAuthenticated?(
              <Box flexGrow={1}>
              <CustomBreadcrumbs />
              </Box>
            ):<></>}
          
            {isAuthenticated ? <SignOutButton /> : <SignInButton />}
          </Toolbar>
          
        </AppBar>
      </Box>
      {props.children}
      <Box pt={4}>
      <Copyright/>
      </Box>
      
      
    </>
  );
};
